import React, { Component } from "react";
import { ArrowBackCircle } from "react-ionicons";
import _post from "../Functions/Post";
import constantURI from "../URI";

class SalesTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      loading: false,
      selectedYear: new Date().getFullYear(),
      selectedMonth : new Date().getMonth() + 1
    };
  }

  arrowback = () => {
    this.props.history.push("./LandingPage");
  };

  getData = async () => {
     const IdClientDetails = JSON.parse(localStorage.getItem("IdClientDetails"));
    const token = JSON.parse(localStorage.getItem("Token"));
    const userId = JSON.parse(localStorage.getItem("UserId"));

    await this.setState({
      IdClientDetails: IdClientDetails,
    });

  const GetAchievementReport =
      constantURI() +
      "GetAchievementReport?token=" +
      token +
      "&limit=" +
      0 +
      "&year=" +
      this.state.selectedYear +
      "&period_type=" +
      "monthly" +
  "&month=" +
this.state.selectedMonth +
      "&salesperson_id=" +
            userId +
      "&achieved=" +
      false;

    await _post(GetAchievementReport).then((response) => {
      return response.json().then(async (data) => {
        if (data !== undefined) {
          await this.setState({ Data: data.records});
          console.log(data)
          console.log(this.state.Data)
        }
      });
    });
  };

  render() {
    console.log(this.state.selectedYear)
    return (
      <div className="dashboard-container">

        {/* Header */}
    

        {/* Back Button */}
        <div className="back-btn-container">
          <ArrowBackCircle
            className="btn back-btn"
            onClick={this.arrowback}
            color="#65a0ff"
            height="50px"
            width="50px"
          />
        </div>
            <div className="header text-center">
          <h2 className="text-center">📊 Sales Data</h2>
          <p >Click the button to load sales information</p>
        </div>
    <div style={{ display: "flex", gap: "15px", marginBottom: "20px" }}>
  
  {/* Year dropdown */}
  <div style={{ display: "flex", flexDirection: "column", width: "150px" }}>
    <label style={{ marginBottom: "5px", fontWeight: "bold" }}>Year</label>
    <div className="custom-select" style={{ position: "relative" }}>
      <select
        className="select-style form-control"
        value={this.state.selectedYear || new Date().getFullYear()}
        onChange={(e) => this.setState({ selectedYear: e.target.value })}
      >
        <option value="">Select Year</option>
        {[2020, 2021, 2022, 2023, 2024, 2025, 2026].map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
      <div className="select-arrow"></div>
    </div>
  </div>

  {/* Month dropdown */}
  <div style={{ display: "flex", flexDirection: "column", width: "150px" }}>
    <label style={{ marginBottom: "5px", fontWeight: "bold" }}>Month</label>
    <div className="custom-select" style={{ position: "relative" }}>
      <select
        className="select-style form-control"
        value={this.state.selectedMonth || new Date().getMonth() + 1}
        onChange={(e) => this.setState({ selectedMonth: e.target.value })}
      >
        <option value="">Select Month</option>
        {[
          "1", "2", "3", "4",
          "5", "6", "7", "8",
          "9", "10", "11", "12"
        ].map((month, index) => (
          <option key={index} value={index + 1}>
            {month}
          </option>
        ))}
      </select>
      <div className="select-arrow"></div>
    </div>
  </div>

</div>

        {/* Button */}
        <div style={{ textAlign: "right", marginBottom: "30px" }}>
          <button className="btn btn-primary" onClick={this.getData}>
            GET DATA
          </button>
        </div>

        {/* Loading */}
        {this.state.loading && <p style={{textAlign:"center"}}>Loading...</p>}

        {/* Table */}
        <div className="table-container">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Product Name</th>
                <th>TARGET QTY</th>
                <th>ACHIEVED QTY</th>
                <th>REMAINING QTY</th>
              </tr>
            </thead>

         <tbody>
  {Array.isArray(this.state.Data) && this.state.Data.length > 0 ? (
    this.state.Data.map((item, index) => (
      <tr key={index}>
        <td>{item.product?.name}</td>
        <td>{item.target_quantity}</td>
        <td>{item.achieved_quantity}</td>
        <td>{item.remaining_quantity}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="4" style={{ textAlign: "center" }}>
        No data available
      </td>
    </tr>
  )}
</tbody>

          </table>
        </div>

      </div>
    );
  }
}

export default SalesTable;